<template>
  <div id="system-publisher-policy-add">
    <ipub-model
      :title="params.id ? 'Edit Policy' : 'Add Policy'"
      width="900px"
      :visable="isVisable"
      @confirm="confirm"
      @cancel="cancel"
    >
      <ipub-form ref="publisher-policy-add-form" :model="params" :rules="rules">
        <!--        菜单标题-->
        <ipub-form-item prop="name" label="Menu Title">
          <ipub-input
            placeholder="Enter Menu title here"
            v-model.trim="params.name"
          />
        </ipub-form-item>

        <!--        菜单类型-->
        <ipub-form-item prop="type" label="Menu Type">
          <ipub-select
            placeholder="Menu Type"
            optionKey="id"
            v-model="params.type"
          >
            <ipub-select-option
              :value="menu.value"
              v-for="(menu, index) in menuTypes"
              :key="index"
              >{{ menu.label }}
            </ipub-select-option>
          </ipub-select>
        </ipub-form-item>

        <!--        选择父级菜单-->
        <ipub-form-item prop="parentId" label="Parent Policy">
          <ipub-select
            placeholder="Select Parent Menu"
            :options="tree"
            :optionsHeight="400"
            :tree="true"
            optionKey="id"
            v-model="params.parentId"
          />
        </ipub-form-item>

        <!--        如果是外部链接,填写链接-->
        <ipub-form-item
          prop="code"
          label="Code"
          v-if="params.type === 'CUSTOMIZE' || params.type === 'SYSTEM'"
        >
          <!--          自定义页面-->
          <template v-if="params.type === 'CUSTOMIZE'">
            <ipub-input placeholder="Enter code here" v-model="params.code" />
          </template>

          <!--          系统页面-->
          <template v-if="params.type === 'SYSTEM'">
            <ipub-select
              placeholder="System Menu"
              optionKey="id"
              v-model="params.code"
            >
              <ipub-select-option
                :value="menu.value"
                v-for="(menu, index) in systemPages"
                :key="index"
                >{{ menu.label }}
              </ipub-select-option>
            </ipub-select>
          </template>
        </ipub-form-item>

        <!--        如果是自定义页面,填写页面内容-->
        <ipub-form-item
          prop="content"
          label="Content"
          v-if="params.type === 'CUSTOMIZE'"
        >
          <ipub-editor
            :height="400"
            placeholder="Enter policy details here"
            v-model="params.content"
          />
        </ipub-form-item>

        <!--        如果是外部链接,填写链接-->
        <ipub-form-item
          prop="externalLink"
          label="External Link"
          v-if="params.type === 'LINK'"
        >
          <ipub-input
            placeholder="Enter external link here"
            v-model="params.externalLink"
          />
        </ipub-form-item>

        <!--        排序-->
        <ipub-form-item prop="sort" label="Sort">
          <ipub-input placeholder="Enter sort" v-model.number="params.sort" />
        </ipub-form-item>

        <!--        生成菜单-->
        <ipub-radio
          :checked="params.menuGenerated"
          @change="changeMenuGenerated"
          label="Menu Generation"
          class="mar-b-12"
        />

        <!--        备注-->
        <ipub-form-item prop="comment" label="Description">
          <ipub-input
            placeholder="Enter description here"
            v-model="params.comment"
          />
        </ipub-form-item>
      </ipub-form>
      <div slot="footer">
        <ipub-button
          plain
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="cancel"
          >Cancel
        </ipub-button>
        <ipub-button
          type="primary"
          :style="{ minWidth: '150px' }"
          @click="confirm"
          >Submit
        </ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pmenu from '../../../../api/pmenu'

export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    tree: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      params: {
        menuGenerated: true
      },
      rules: {},
      menuTypes: [
        {
          label: 'System',
          value: 'SYSTEM',
        },
        {
          label: 'Customize',
          value: 'CUSTOMIZE',
        },
        {
          label: 'Link',
          value: 'LINK',
        },
      ],
      systemPages: [
        {
          label: 'Management Team',
          value: 'management_team',
        },
        {
          label: 'Search',
          value: 'search',
        },
        {
          label: 'Journals',
          value: 'journals',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
    }),
  },
  watch: {
    isVisable(val) {
      if (!val) {
        this.params = {
          menuGenerated: true
        }
      }
    },
  },
  mounted() {
    this.getRules()
  },
  methods: {
    changeMenuGenerated(e) {
      this.params.menuGenerated = !this.params.menuGenerated
    },
    setParentId(id) {
      this.params.parentId = id
    },
    async getQuery(id) {
      this.$nextTick(async ()=>{
        this.params = await pmenu.query(id)
      })
    },
    async confirm(val) {
      const flag = this.$refs['publisher-policy-add-form'].validate()
      if (flag) {
        const data = Object.assign(this.params, {
          code: this.params.type
            ? this.params.code
            : this.params.name
                .toLowerCase()
                .replace(' & ', '_')
                .replace(/\s/g, '_'),
          released: val,
        })
        if (data.type === 'CUSTOMIZE' || data.type === 'SYSTEM') {
          if (!data.code) {
            this.$message.error({
              title: 'Error',
              content: 'Please enter menu code',
            })
            return
          }
          if (data.code.includes('/')) {
            this.$message.error({
              title: 'Error',
              content: 'Menu code cannot contain a slash (/) character',
            })
            return
          }

          if (data.code.length >= 512) {
            this.$message.error({
              title: 'Error',
              content: 'Policy title: Maxium 512 characters',
            })
            return
          }
        }

        if (this.params.id) {
          await pmenu.edit(this.params.id, data)
          this.$message.success({
            title: 'Success',
            content: 'This Publisher Policy has been Created!',
          })
        } else {
          await pmenu.add(data)
          this.$message.success({
            title: 'Success',
            content: 'This Publisher Policy has been saved!',
          })
        }
        this.$emit('confirm', data)
      }
    },
    preview() {},
    cancel() {
      this.$emit('cancel')
    },
    getRules() {
      this.rules = {
        name: [
          {
            required: true,
            message: 'Policy Title' + this.LANGUAGE[this.language].noEmpty,
          },
          {
            max: 100,
            message: 'Policy title: Maxium 100 characters',
          },
        ],
        type: [
          {
            required: true,
            message: 'Please select menu type',
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#system-banners-add {
  .upload-content {
    height: 180px;
    width: 280px;
    background: $content_color;
    border: 1px solid $border_color;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
